import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DataTables from "../../Components/Tables/DataTable";
import { titleCase } from "../../utils/case";
import { getLogs } from "../../api/log.api";
import { Input } from "reactstrap";

const ActivityLogMain = () => {
  const { t } = useTranslation();

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [meta, setMeta] = useState({
    total: 0,
    page: 1,
    perPage: 10,
    totalPages: 1,
  });

  const fetchLogs = async (page = 1, perPage = 10, keyword = "") => {
    try {
      const res = await getLogs({
        page,
        perPage,
        search: keyword,
      });

      setData(res?.data || res || []);
      setMeta(
        res?.meta || {
          total: 0,
          page,
          perPage,
          totalPages: 1,
        }
      );
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    fetchLogs(meta.page, meta.perPage, search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (newPage) => {
    fetchLogs(newPage, meta.perPage, search);
  };

  const handlePerPageChange = (newPerPage) => {
    fetchLogs(1, newPerPage, search);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    fetchLogs(1, meta.perPage, value);
  };

  // Build human-readable activity sentence
  const buildActivity = (row) => {
    const action = row.action;
    const model = row.model;
    const name = row.data?.name || `ID ${row.modelId}`;

    if (action === "create") {
      return `Created ${model} "${name}"`;
    }

    if (action === "update") {
      return `Updated ${model} "${name}"`;
    }

    if (action === "delete") {
      return `Deleted ${model} "${name}"`;
    }

    return `${action} ${model} "${name}"`;
  };

  const columns = [
    {
      name: titleCase(t("activity")),
      selector: (row) => buildActivity(row),
      wrap: true,
      sortable: false,
    },
    {
      name: titleCase(t("date")),
      selector: (row) =>
        row.createdAt
          ? new Date(row.createdAt).toLocaleString()
          : "-",
      sortable: true,
      wrap: true,
    },
  ];

  const action = (
    <div style={{ width: "250px" }}>
      <Input
        type="text"
        placeholder={titleCase(t("search"))}
        value={search}
        onChange={handleSearchChange}
      />
    </div>
  );

  return (
    <DataTables
      parent={titleCase(t("log"))}
      title={titleCase(t("activity logs"))}
      mainTitle={titleCase(t("activity logs"))}
      initialData={data}
      columns={columns}
      meta={meta}
      onPageChange={handlePageChange}
      onPerPageChange={handlePerPageChange}
      hideAction
      action={action}
    />
  );
};

export default ActivityLogMain;